<template>
  <div class="app-content pt-3 p-md-3 p-lg-4">
    <div class="container-fluid">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h1 class="app-page-title mb-0">PG Staff / Coordinators</h1>
      </div>

      <div class="app-card shadow-sm mb-4">
        <div class="app-card-body p-4">
          <div class="row mb-3">
            <div class="col-md-4">
              <b-form-input
                v-model="filter"
                placeholder="Search staff..."
                debounce="300"
              ></b-form-input>
            </div>
          </div>

          <div v-if="loading" class="text-center my-4">
            <b-spinner variant="primary"></b-spinner>
            <div class="mt-2 text-muted">Loading staff...</div>
          </div>

          <b-table
            v-else
            :items="staff"
            :fields="fields"
            :filter="filter"
            :per-page="perPage"
            :current-page="currentPage"
            responsive
            striped
            hover
            show-empty
          >
            <template #empty>
              <div class="text-center text-muted py-4">No staff found.</div>
            </template>
            <template #cell(index)="data">
              {{ (currentPage - 1) * perPage + data.index + 1 }}
            </template>
            <template #cell(lecturer_category)="data">
              <b-badge variant="primary">{{ data.value }}</b-badge>
            </template>
            <template #cell(is_verified)="data">
              <b-badge :variant="data.value && data.value !== 0 ? 'success' : 'danger'">
                {{ data.value && data.value !== 0 ? 'Enabled' : 'Disabled' }}
              </b-badge>
            </template>
            <template #cell(actions)="data">
              <button
                class="btn btn-sm"
                :class="data.item.is_verified && data.item.is_verified !== 0 ? 'btn-warning' : 'btn-success'"
                @click="toggleStatus(data.item)"
                :disabled="togglingId === data.item.id"
              >
                <b-spinner small v-if="togglingId === data.item.id"></b-spinner>
                <template v-else>
                  {{ data.item.is_verified && data.item.is_verified !== 0 ? 'Disable' : 'Enable' }}
                </template>
              </button>
            </template>
          </b-table>

          <div class="d-flex justify-content-between align-items-center" v-if="staff.length > perPage">
            <small class="text-muted">{{ staff.length }} staff total</small>
            <b-pagination
              v-model="currentPage"
              :total-rows="staff.length"
              :per-page="perPage"
              size="sm"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      staff: [],
      loading: false,
      filter: "",
      perPage: 20,
      currentPage: 1,
      togglingId: null,
      fields: [
        { key: "index", label: "#", class: "text-center", thStyle: { width: "50px" } },
        { key: "email", label: "Email", sortable: true },
        { key: "deptname", label: "Department", sortable: true },
        { key: "lecturer_category", label: "Role", class: "text-center", sortable: true },
        { key: "is_verified", label: "Status", class: "text-center", sortable: true },
        { key: "session_last_seen", label: "Last Session", sortable: true },
        { key: "actions", label: "Actions", class: "text-center", thStyle: { width: "120px" } },
      ],
    };
  },
  created() {
    this.loadStaff();
  },
  methods: {
    loadStaff() {
      this.loading = true;
      axios
        .post("admin/get/pg/coords/for/hod", { role: "admin" })
        .then((res) => {
          this.staff = res.data.pg_coords || [];
        })
        .catch(() => Toast.fire({ icon: "error", title: "Failed to load staff" }))
        .finally(() => (this.loading = false));
    },
    toggleStatus(item) {
      let action = item.is_verified && item.is_verified !== 0 ? "disable" : "enable";
      Swal.fire({
        title: `${action.charAt(0).toUpperCase() + action.slice(1)} Staff?`,
        text: `Are you sure you want to ${action} ${item.email}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: `Yes, ${action}`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.togglingId = item.id;
          axios
            .post("admin/enable/or/disable/pg/coords", { id: item.id })
            .then((res) => {
              let msg = res.data["Enable-status"] || res.data["Disable-status"] || "Status updated";
              Toast.fire({ icon: "success", title: msg });
              this.loadStaff();
            })
            .catch(() => Toast.fire({ icon: "error", title: "Failed to update status" }))
            .finally(() => (this.togglingId = null));
        }
      });
    },
  },
};
</script>
